import { NodeList } from "./Collections/NodeList"
import { Node } from "./Collections/Node";
import { IDictionary } from "./Collections/Dictionary";



export interface IAudioSprite {
    /**
     * Cas startu ve vterinach
     */
    start: number,
    /**
     * Cas konce ve vterinach
     */
    end: number,
    /**
     * True, pokud se ma zvuk prehravat ve smycce
     */
    loop: boolean,
    /**
     * If true then sounds played from slot will be played independently of each other.
     */
    overlap?: boolean
}



export class AudioManager extends pc.EventHandler {
    /**
     * Udalost vyvolana po zmene isMuted
     * Parametry:
     * - this
     * - isMuted: boolean
     */
    static readonly EVENT_MUTE_CHANGED = "audioMng:muteChanged";
    /**
     * Udalost vyvolana pri zastaveni zvuku pres metodu stop()
     * Parametry:
     * - this
     */
    static readonly EVENT_STOP = "audioMng:stop";
    /**
     * Seznam vsech pc.SoundComponent, ktere spravce ovlada
     */
    private _components: NodeList<pc.SoundComponent>;
    private _instances: IDictionary<pc.SoundInstance>;
    /**
     * True, pokud se nemaji prehravat zadne zvuky
     */
    get isMuted(): boolean { return this._isMuted; }
    set isMuted(val: boolean) {
        if (this._isMuted != val) {
            this._isMuted = val;
            this.fire(AudioManager.EVENT_MUTE_CHANGED, this, val);
        }
    }

    private _isPaused: boolean = false;
    private _isMuted: boolean = false;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super();
        this._components = new NodeList<pc.SoundComponent>();
        this._instances = {};
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    createSoundComponent(entity: pc.Entity, data?: any): void {
        this._components.add(entity.addComponent(pc.eCompomentType.sound, data) as pc.SoundComponent);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    addComponent(component: pc.SoundComponent): void {
        this._components.add(component);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    remComponent(component: pc.SoundComponent): void {
        this._components.every((c: pc.SoundComponent, node: Node<pc.SoundComponent>): boolean => {
            if (c == component) {
                this._components.removeByNode(node);
                return false;
            }

            return true;
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    pause(): void {
        if (!this._isPaused) {
            this._isPaused = true;
            this._components.forEach((c: pc.SoundComponent) => { c.pause(); });
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    resume(): void {
        if (this._isPaused) {
            this._isPaused = false;
            this._components.forEach((c: pc.SoundComponent) => { c.resume(); });
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    stop(): void {
        // Volat stop pro vsechny instance
        for (const key in this._instances) {
            let ins = this._instances[key];

            if (ins.isPlaying)
                ins.stop();
        }

        this.fire(AudioManager.EVENT_STOP, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    playSound(entity: pc.Entity | pc.SoundComponent, slotName: string): pc.SoundInstance {
        let ins = this._instances[slotName];

        if (!this._isMuted) {
            if (!ins) {
                ins = (entity instanceof pc.Entity ? entity.sound : entity).play(slotName);
                this._instances[slotName] = ins;
            }
            else {
                ins.play();
            }
        }

        return ins;
    }

    //-------------------------------------------------------------------------
    /**
     * Vytvori pc.SoundSlot v zadane pc.Entity. Entity musi mit pc.SoundComponent
     */
    //-------------------------------------------------------------------------
    addSoundSlot(entity: pc.Entity, slotName: string, sprite: IAudioSprite, assetId: number): pc.SoundSlot {
        return entity.sound.addSlot(slotName, {
            asset: assetId,
            loop: sprite.loop,
            startTime: sprite.start,
            duration: sprite.end - sprite.start
        });
    }
}